import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-calendarbase',
    templateUrl: './calendarbase.component.html',
    styleUrls: ['./calendarbase.component.css'],
})
export class CalendarbaseComponent implements OnInit {

    constructor(
    ) { }

    ngOnInit() {
    }

}
